import { DATE_SHORT_FORMAT } from '../../../../constants/date'
import { toListingUserCellValue } from '../../../RentalPortalListing'
import {
  TableDateCell,
  TableTextCell,
  TableTitleCell,
  TableUserCell,
} from '../../../Table'
import { RENTAL_PORTAL_ARCHIVE_COLUMN_NAME } from '../RentalPortalArchive.constants'
import { getRentalPortalArchiveObjectType } from '../RentalPortalArchive.utils'

import { RENTAL_PORTAL_ARCHIVE_OBJECT_TYPE_ICON } from './RentalPortalArchiveTableRow.constants'

import ArchiveIcon from '../../../../icons/archive.svg'

function getRentalPortalArchiveObjectIcon(objectType) {
  return RENTAL_PORTAL_ARCHIVE_OBJECT_TYPE_ICON[objectType] ?? ArchiveIcon
}

export function renderCell({ item, name, t, ...restProps }) {
  const { [name]: value } = item

  switch (name) {
    case RENTAL_PORTAL_ARCHIVE_COLUMN_NAME.ObjectName:
      return (
        <TableTitleCell
          {...restProps}
          avatarProps={{
            Icon: getRentalPortalArchiveObjectIcon(item.object_type),
            text: value,
          }}
          value={value}
        />
      )
    case RENTAL_PORTAL_ARCHIVE_COLUMN_NAME.ObjectType:
      return (
        <TableTextCell
          {...restProps}
          value={t(getRentalPortalArchiveObjectType(value).label)}
        />
      )
    case RENTAL_PORTAL_ARCHIVE_COLUMN_NAME.ArchivedAt:
      return (
        <TableDateCell
          {...restProps}
          dateFormat={DATE_SHORT_FORMAT}
          useTodayFormat={false}
          value={value}
        />
      )
    case RENTAL_PORTAL_ARCHIVE_COLUMN_NAME.ResponsibleUser:
      return (
        <TableUserCell {...restProps} value={toListingUserCellValue(value)} />
      )
    default:
      return <TableTextCell {...restProps} value={value} />
  }
}
